import React from 'react'
import { InlineWidget, useCalendlyEventListener } from 'react-calendly'

import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Heading } from '@/components/ui/heading'
import LoadingOverlay from '@/components/widgets/LoadingOverlay'
import LoadingWidget from '@/components/widgets/LoadingWidget'

interface Props {
  companyName: string
  scheduleCallUrl: string
  onCallScheduled: () => void
  onHide: () => void
  isProcessing: boolean
}

const CalendlyModal: React.FC<Props> = ({
  companyName,
  scheduleCallUrl,
  onCallScheduled,
  onHide,
  isProcessing,
}) => {
  useCalendlyEventListener({
    onEventScheduled: () => {
      onCallScheduled()
    },
  })

  return (
    <>
      <Dialog open onHide={onHide}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Schedule a meeting</DialogTitle>
          </DialogHeader>

          <LoadingOverlay isActive={isProcessing}>
            <DialogBody>
              <Heading size={2}>{companyName}</Heading>

              <InlineWidget
                url={scheduleCallUrl}
                styles={{ width: '100%', height: '700px' }}
                pageSettings={{ hideGdprBanner: true }}
                LoadingSpinner={LoadingWidget}
              />
            </DialogBody>
          </LoadingOverlay>
        </DialogContent>
      </Dialog>
    </>
  )
}

export default CalendlyModal
